'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/statuses', null, {
            get: {method: 'GET'},
            default: {url: 'api/statuses/default', method: 'get'},
        });
    }];